import { Button } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import {
  useIntegrationDisconnect,
  useIntegrations,
} from '../../../../../integrations/hooks/useIntegrations';

export type ConnectButtonProps = {
  providerName: string;
  userId: string;
  category: string;
};

const ConnectButton = ({
  providerName,
  userId,
  category,
}: ConnectButtonProps): ReactElement | null => {
  const { t } = useTranslation();
  const { onClickConnect, isConnecting, providerCategories } = useIntegrations();
  const isConnected = providerCategories?.some((c) =>
    c.connectedProviders.some((p) => p.provider.name === providerName),
  );
  const { mutate, isPending } = useIntegrationDisconnect();

  return (
    <Button
      size="sm"
      fontSize="md"
      variant="outline"
      colorScheme={isConnected ? 'red.500' : 'gray.900'}
      w="full"
      mt="auto"
      isLoading={isConnecting || isPending}
      onClick={
        isConnected
          ? () =>
              mutate({
                params: {
                  integrationName: providerName,
                },
                category,
              })
          : () =>
              onClickConnect({
                integrationId: providerName,
                connectionId: userId,
              })
      }
    >
      {t(isConnected ? 'global.disconnect' : 'global.connect')}
    </Button>
  );
};
export default ConnectButton;
